import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./HomeContent.css";

function HomeContent() {
  return (
    <>
      <div className="main-container">
        <title>Delivery</title>
      </div>
      <div className="main-container">
        <div className="delivery-wrap">
          <div className="delivery-row row1">
            <div className="delivery-box">
              <h1>High-Speed Delivery</h1>
              {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p> */}
            </div>
          </div>
          <div className="delivery-row row2">
            <div className="delivery-box">
              <img
                src="images/Home/delivery_img.png"
                alt="Transformation"
                className="learn-img"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="stay-container">
        <div className="stay-wrap">
          <div className="stay-row">
            <div className="stay-box">
              <h2>Delivery offerings</h2>
            </div>
          </div>
        </div>
      </div>
      {/* <Carousel
        showThumbs={true}
        showStatus={false}
        infiniteLoop
        autoPlay={true}
        useKeyboardArrows
        transitionTime={1000}
      > */}
      <div className="learncard-container main-carousel">
        <div className="learncard-wrap">
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/Agile"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/Agile_new.jpg"
                  alt="Agile"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>Agile</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      Accenture helps create a culture of innovation and brings
                      Development and Operations together, fully harnessing the
                      power of modern engineering techniques supported by
                      coaching, advisory and training.
                      <span style={{ visibility: "hidden" }}>
                        significance to building depth and breadth across
                        multiple skills across.
                      </span>
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/Agile"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          className="Arrow-img"
                          alt="Arrow"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/home"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/AO.png"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>AMS</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      {" "}
                      Welcome to ATCI Application Management Services (AMS) Learning
                      journey that provides a clear learning path for employees
                      at each career level across application outsourcing and
                      maintenance skills.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/home"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/DevOps"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/devops_new.jpg"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>DevOps</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      Application delivery has shifted from large-scale,
                      project-based implementations to a continuous evolution.
                      DevOps makes this possible by bringing business,
                      development and operation teams together and applying
                      automated processes to streamline IT.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/DevOps"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/DLF/"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/DFA.png"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>DLF</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      Delivery Learning Framework (DLF) 3.0. DLF 3.0 is an
                      enhanced version of the existing DLF 2.0 and is a set of
                      pre-defined trainings for all career levels from Associate
                      to Senior Managers.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/DLF/"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/TT/home"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/TT_new.jpg"
                  alt="Transformation"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>IE</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      At Accenture, Talent Transformation is at the core of our
                      heart. While building deep expertise in core skills is our
                      focus, we also give equal significance to building depth
                      and breadth across multiple skills across technology and
                      industry.
                      <span style={{ visibility: "hidden" }}>
                        significance to building depth and breadth.
                      </span>
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/TT/home"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/leadershipprograms/home"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/LP.png"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>Leadership Programs</h3>
                  <div className="figureContent">
                    <p className="textContent"> </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/leadershipprograms/home"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/ProjectManagement/"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/PM.png"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>PM</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      {" "}
                      In Project Management courses, you will learn how to drive
                      optimal project performance and successfully deliver your
                      projects using today’s best practices and methods in
                      traditional and Agile Scrum project management.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/ProjectManagement/"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/SystemIntegration/"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/SI.png"
                  alt="DevOps"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>SI</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      {" "}
                      System integration (SI) is a process that connects the
                      various IT system and application in an enterprise so that
                      they work cohesively in a coordinated and unified manner.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/SystemIntegration/"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/SRE"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/SRE_new.jpg"
                  alt="SRE"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>SRE</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      Site Reliability Engineering (SRE), focuses on delivering
                      ultra-scalable and highly reliable software systems.SRE
                      team uses an engineering-based approach to manage systems,
                      solve problems, and automate operations tasks.
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/SRE"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>

          <div className="learncard-row">
            <a
              href="https://atci.lkm.delivery.accenture.com/TechCore/home"
              target="_blank"
            >
              <figure className="effect-selena">
                <img
                  src="images/Home/Tech core_new.jpg"
                  alt="TechCore"
                  className="learncard-img"
                />
                <figcaption>
                  <h3>Tech Core</h3>
                  <div className="figureContent">
                    <p className="textContent">
                      Technology Core Learning journey provides a clear learning
                      path for employees at each career level across delivery
                      and professional skills.
                      <span style={{ visibility: "hidden" }}>
                        significance to building depth and breadth.
                      </span>
                    </p>
                    <p className="Explore">
                      <a
                        href="https://atci.lkm.delivery.accenture.com/TechCore/home"
                        target="_blank"
                        className="exploreBtn"
                      >
                        <span>Explore More</span>{" "}
                        <img
                          src="images/Home/arrow-white.png"
                          alt="Arrow"
                          className="Arrow-img"
                        />
                      </a>
                    </p>
                  </div>
                </figcaption>
              </figure>
            </a>
          </div>
        </div>

        {/* <div className="learncard-container main-carousel1"> */}
        <div className="learncard-wrap"></div>
      </div>
      {/* </Carousel> */}
      <div className="links-container">
        <div className="links-wrap">
          <div className="link-row">
            <div className="followLink">
              <img
                src="images/Home/Acc_symbol GT_Dimensional_RGB.png"
                alt="AccentureIcon"
                className="accenture-icon"
              />
              <p className="follow-site">Follow our site</p>
            </div>
          </div>
          <div className="link-row">
            <div className="link-box">
              <p>
                <span>Quick links</span>
              </p>
              <a href="#" target="_blank">
                My Learning{" "}
                <img
                  src="images/Home/new page.png"
                  alt="PopupIcon"
                  className="links-icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default HomeContent;
